module.exports = __webpack_public_path__ + "static/media/dep8.f7147875.jpg";